import React from "react";

import DailyCustomerPortfolioDetail from "components/Tvendo/Sale/DataMaster/DailyCustomerPortfolioDetail/List.js";

export default function () {
  return <DailyCustomerPortfolioDetail />;
}
